import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Button, CircularProgress, Collapse, Link, Typography } from '@mui/material';
import React from 'react';
import { ResponsiveActionToolbar } from '../../ResponsiveActionToolbar';
import { useCommonDataTableUiTranslation } from '../../hooks';
export function LocalActionsBar({ loading, filteredRowCount, rows, rowSelectionEnabled, selectedRowIds, onDeselectAllRows, selectedRowCountLabel, filtered, filteredRowCountLabel, localActions, localActionStatic, }) {
    const { t } = useCommonDataTableUiTranslation();
    const [stickyElement, setStickyElement] = React.useState();
    React.useEffect(() => {
        let observer = undefined;
        if (!localActionStatic) {
            if (stickyElement) {
                observer = new IntersectionObserver(([entry]) => {
                    const pinned = entry.intersectionRatio < 1;
                    const element = entry.target;
                    element.style.borderTop = pinned ? '1px solid transparent' : '';
                    element.style.borderTopLeftRadius = pinned ? '0' : '';
                    element.style.borderTopRightRadius = pinned ? '0' : '';
                    element.style.boxShadow = pinned ? '0px 2px 2px rgba(0, 0, 0, 0.2)' : '';
                }, {
                    threshold: [1],
                });
                observer.observe(stickyElement);
            }
        }
        return () => {
            if (observer) {
                observer.disconnect();
            }
        };
    }, [stickyElement, localActionStatic]);
    const showSelected = rowSelectionEnabled && selectedRowIds != null && selectedRowIds.length > 0;
    const showLoading = !showSelected && loading && rows.length > 0 && filtered;
    const showFiltered = !showSelected && !showLoading && filtered;
    const showBar = localActions && localActions.length > 0 && (showSelected || showLoading || showFiltered);
    return (React.createElement(Collapse, { in: showBar, ref: (element) => setStickyElement(element), sx: localActionStatic
            ? undefined
            : {
                position: 'sticky',
                top: -1,
                zIndex: 1,
            } },
        React.createElement(Box, { sx: {
                px: 2,
                py: 1,
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                borderTopLeftRadius: 4,
                borderTopRightRadius: 4,
                backgroundColor: themeColors.accent.blue.subtlest,
            }, "data-test": 'local-actions-bar' }, showBar ? (React.createElement(React.Fragment, null,
            React.createElement(Typography, { variant: 'subtitle2', sx: {
                    flexShrink: 1,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    color: showLoading ? themeColors.text.subtle : themeColors.text.bold,
                }, "data-test": 'row-count' },
                showSelected &&
                    (selectedRowCountLabel
                        ? selectedRowCountLabel(selectedRowIds.length)
                        : t('selectedRowCount', { count: selectedRowIds.length })),
                showLoading && React.createElement(CircularProgress, { size: 18, color: 'inherit' }),
                showFiltered &&
                    filteredRowCount != null &&
                    (filteredRowCountLabel
                        ? filteredRowCountLabel(filteredRowCount)
                        : t('filteredRowCount', { count: filteredRowCount }))),
            showSelected && onDeselectAllRows && (React.createElement(Typography, { variant: 'body2', sx: { flexShrink: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } },
                React.createElement(Link, { component: 'button', onClick: () => onDeselectAllRows(), "data-test": 'deselectAll' }, t('deselectAll')))),
            React.createElement(ResponsiveActionToolbar, { actions: filteredRowCount === 0 ? localActions === null || localActions === void 0 ? void 0 : localActions.map((action) => (Object.assign(Object.assign({}, action), { disabled: true }))) : localActions, align: 'right', sx: { flexGrow: 1, flexShrink: 1, overflow: 'hidden' } }))) : (React.createElement(Button, { tabIndex: -1, sx: { visibility: 'hidden' } }, "\u00A0")))));
}
